import { RenderElementProps } from 'slate-react';
import {
  EXERCISE_GAP_FILL_WITH_HINT_QUESTION_CONTENT
} from '../../figma/BlogEditor/plugins/ExerciseGapFillWithHint/types';
import * as React from 'react';
import {
  GapFillWithHintBlank
} from './components/GapFillWithHintBlank';
import {
  GapFillBlank
} from './components/GapFillBlank';

export const EditorExerciseBlankElement = (props: RenderElementProps) => {
  const { element } = props;

  switch (element.parentNodeType) {
    case EXERCISE_GAP_FILL_WITH_HINT_QUESTION_CONTENT: {
      return <GapFillWithHintBlank {...props} />;
    }
    default:
  }
  return <GapFillBlank {...props} />;
};
